import _regeneratorRuntime from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.min-safe-integer";

var startHardwareBackButton = function startHardwareBackButton() {
  var doc = document;
  var busy = false;
  doc.addEventListener('backbutton', function () {
    if (busy) {
      return;
    }

    var handlers = [];
    var ev = new CustomEvent('ionBackButton', {
      bubbles: false,
      detail: {
        register: function register(priority, handler) {
          handlers.push({
            priority: priority,
            handler: handler
          });
        }
      }
    });
    doc.dispatchEvent(ev);

    if (handlers.length > 0) {
      var selectedPriority = Number.MIN_SAFE_INTEGER;
      var selectedHandler;
      handlers.forEach(function (_ref) {
        var priority = _ref.priority,
            handler = _ref.handler;

        if (priority >= selectedPriority) {
          selectedPriority = priority;
          selectedHandler = handler;
        }
      });
      busy = true;
      executeAction(selectedHandler).then(function () {
        return busy = false;
      });
    }
  });
};

var executeAction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(handler) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!handler) {
              _context.next = 6;
              break;
            }

            result = handler();

            if (!(result != null)) {
              _context.next = 6;
              break;
            }

            _context.next = 6;
            return result;

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function executeAction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var OVERLAY_BACK_BUTTON_PRIORITY = 100;
var MENU_BACK_BUTTON_PRIORITY = 99; // 1 less than overlay priority since menu is displayed behind overlays

export { MENU_BACK_BUTTON_PRIORITY, OVERLAY_BACK_BUTTON_PRIORITY, startHardwareBackButton };